export default __webpack_public_path__ + "static/media/secure.d6b6527a.svg";